var exports = {
  "iE": "xaee3c4fa--17a352--wrapper",
  "su": "xaee3c4fa--17a352--icon-wrapper",
  "i9": "xaee3c4fa--17a352--_clickable",
};

module.exports = exports;
